import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DesktopMyStylistPage.css';

const ArrowSvg = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginLeft: 18}}>
    <path d="M10 7L18 14L10 21" stroke="#b8a98a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const IconCircle = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9.5" stroke="#b8a98a" strokeWidth="2"/></svg>
);
const IconSquare = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="4" y="4" width="16" height="16" rx="3" stroke="#b8a98a" strokeWidth="2"/></svg>
);
const IconRect = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="4" y="8" width="16" height="8" rx="2" stroke="#b8a98a" strokeWidth="2"/></svg>
);
const IconGrid = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="4" y="4" width="16" height="16" rx="3" stroke="#b8a98a" strokeWidth="2"/><path d="M4 12H20" stroke="#b8a98a" strokeWidth="2"/><path d="M12 4V20" stroke="#b8a98a" strokeWidth="2"/></svg>
);
const IconDiamond = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="6" y="6" width="12" height="12" rx="2" transform="rotate(45 12 12)" stroke="#b8a98a" strokeWidth="2"/></svg>
);

const desktopCardGroups = [
  {
    group: [
      {
        title: 'Choose Vibes',
        description: 'Catch the vibe — let’s roll!',
        recommend: true,
        icon: <IconSquare />,
      },
    ],
  },
  {
    group: [
      {
        title: 'Style',
        description: 'Your preferred fashion style.',
        recommend: false,
        icon: <IconCircle />,
      },
      {
        title: 'Occasion',
        description: 'What is the event or scenario?',
        recommend: false,
        icon: <IconCircle />,
      },
    ],
  },
  {
    group: [
      {
        title: 'Body Type',
        description: 'Highlight your unique shape.',
        recommend: false,
        icon: <IconRect />,
      },
      {
        title: 'Weather',
        description: 'Adapt to the climate.',
        recommend: false,
        icon: <IconGrid />,
      },
    ],
  },
  {
    group: [
      {
        title: 'Find Matches',
        description: 'Find items that fit your vibe.',
        recommend: false,
        icon: <IconDiamond />,
      },
    ],
  },
];

const DesktopMyStylistPage: React.FC = () => {
  const navigate = useNavigate();

  const handleCardClick = (title: string) => {
    // Vibes 先跳转到小球界面
    if (title === 'Choose Vibes') {
      navigate('/vibe-selection');
      return;
    }
    // 其他类型保持原有逻辑
    let path: string;
    switch (title) {
      case 'Style':
        path = 'style';
        break;
      case 'Occasion':
        path = 'occasion';
        break;
      case 'Body Type':
        path = 'body-type';
        break;
      case 'Weather':
        path = 'weather';
        break;
      case 'Find Matches':
        path = 'find-match';
        break;
      default:
        path = 'style';
    }
    navigate('/chatpage', { state: { path } });
  };

  return (
    <div className="my-stylist-page desktop-version">
      <h2>Discover Your Style</h2>
      <p className="subtitle">Your daily style moodboard—no gatekeeping!</p>
      <div className="desktop-card-groups">
        {/* 第一组大卡片 */}
        <div className="desktop-card-row">
          {desktopCardGroups[0].group.map((card) => (
            <div 
              className="desktop-card desktop-card-large" 
              key={card.title}
              onClick={() => handleCardClick(card.title)}
            >
              {card.icon}
              <div className="desktop-card-content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
              {card.recommend && <span className="desktop-card-recommend">Recommend</span>}
              <ArrowSvg />
            </div>
          ))}
        </div>
        {/* 其余分组两列卡片 */}
        {desktopCardGroups.slice(1).map((group, idx) => (
          <div className="desktop-card-row" key={idx}>
            {group.group.map((card) => (
              <div 
                className="desktop-card" 
                key={card.title}
                onClick={() => handleCardClick(card.title)}
              >
                {card.icon}
                <div className="desktop-card-content">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                </div>
                <ArrowSvg />
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="attraction-booster" onClick={() => navigate('/chatpage', { state: { path: 'attraction' } })}>
        <strong>Attraction Booster</strong>
        <p>Like him/her? Showcase the side you both love.</p>
      </div>
    </div>
  );
};

export default DesktopMyStylistPage; 